var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApacheLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 66 66",
    id: "Layer_1_1598899230408",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.42, -0.91, -0.91, -0.42, 2731.69, -5351.75)",
    y2: 168.28,
    x2: -5995.9,
    y1: 175.53,
    x1: -6002.1,
    id: "linear-gradient_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f69923",
    offset: 0,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79a23",
    offset: 0.31,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: 0.84,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.42, -0.91, -0.91, -0.42, 2731.69, -5351.75)",
    y2: 176.33,
    x2: -6003.75,
    y1: 176.33,
    x1: -6047.97,
    id: "linear-gradient-2_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: 0.32,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: 0.63,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: 0.75,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: 1,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 41.71,
    x2: 39.54,
    y1: 41.71,
    x1: 17.89,
    id: "linear-gradient-3_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662",
    offset: 0,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662e8d",
    offset: 0.1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f2064",
    offset: 0.79,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2032",
    offset: 0.95,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    y2: 30.11,
    x2: 35.81,
    y1: 30.11,
    x1: 16.6,
    id: "linear-gradient-4_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-3_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y2: 45.08,
    x2: 27.61,
    y1: 45.08,
    x1: 20.56,
    id: "linear-gradient-5_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    y2: 31.42,
    x2: 43.36,
    y1: 31.42,
    x1: 15.82,
    id: "linear-gradient-6_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y2: 172.39,
    x2: -6004.01,
    y1: 172.39,
    x1: -6048.23,
    id: "linear-gradient-7_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y2: 170.8,
    x2: -6001.27,
    y1: 170.8,
    x1: -6045.49,
    id: "linear-gradient-8_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y2: 170.96,
    x2: -6001.27,
    y1: 170.96,
    x1: -6045.49,
    id: "linear-gradient-9_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-2_1598899230408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y2: 170.99,
    x2: -6010.87,
    y1: 170.99,
    x1: -6020.65,
    id: "linear-gradient-10_1598899230408",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient_1598899230408)"
    },
    d: "M38.26,10.26a16.28,16.28,0,0,0-3.2,3.23l1.26,2.37A30.34,30.34,0,0,1,39,12.5l.11-.12L39,12.5a27.28,27.28,0,0,0-2.51,3.4,44.69,44.69,0,0,0,4.87-.6c.48-2.69-.47-3.92-.47-3.92S39.68,9.43,38.26,10.26Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M36.13,23.77h0l-.18,0,0,0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M34.85,28l-.31.06Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M34.46,28.08Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e"
    },
    d: "M34.05,30.15l-.5.08h0l.25,0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e",
      opacity: 0.3499999940395355,
      isolation: "isolate"
    },
    d: "M34.05,30.15l-.5.08h0l.25,0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e"
    },
    d: "M34.47,28.08h.07l.31-.06-.38.07Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e",
      opacity: 0.3499999940395355,
      isolation: "isolate"
    },
    d: "M34.47,28.08h.07l.31-.06-.38.07Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-2_1598899230408)"
    },
    d: "M32.62,22c.38-.71.77-1.41,1.16-2.08s.81-1.39,1.23-2.05a.75.75,0,0,1,.07-.12c.41-.65.82-1.27,1.24-1.86l-1.26-2.37-.28.35c-.36.45-.74.94-1.13,1.45s-.88,1.2-1.33,1.85-.84,1.23-1.27,1.88-.72,1.12-1.08,1.7l0,.07L31.56,24C31.91,23.32,32.26,22.64,32.62,22Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-3_1598899230408)"
    },
    d: "M31.5,38.08c-.17.34-.34.64-.51.92a6.39,6.39,0,0,1-3.21,2.62,2.29,2.29,0,0,0,2.2-.81,4.48,4.48,0,0,1-.26.49c-1.06,1.74-3.1,2.34-5.47,2.23a2.64,2.64,0,0,1,.85,1.81,3.24,3.24,0,0,0-1.23-1.45c.29-.86.42-1.23.57-1.65l.09-.26a0,0,0,0,1,0,0c.21-.61.43-1.22.65-1.81l.12-.33h0l1.32-.14A5.16,5.16,0,0,0,31.5,38.08Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-4_1598899230408)"
    },
    d: "M31.56,24l0,.07-.66,1.33c-.12.25-.25.51-.37.77-.34.72-.68,1.45-1,2.18s-.66,1.48-1,2.22l-.93,2.19L26.68,35c-.3.75-.59,1.5-.88,2.23-.06.17-.13.34-.19.5l-.67,1.76-1.63-3.22h0q.27-1.28.63-2.55c.1-.37.21-.73.33-1.09s.29-.87.45-1.33c.26-.7.55-1.44.88-2.21s.61-1.38,1-2.12l.18-.35c.28-.58.58-1.16.89-1.73s.72-1.34,1.1-2,.75-1.28,1.13-1.9l.08-.13Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-5_1598899230408)"
    },
    d: "M24.94,39.44h0c-.05.15-.11.29-.16.44q-.36.95-.69,1.86a.78.78,0,0,1-.05.14l-.18.5c-2.08,5.81-3.41,10.23-3.61,10.91a1,1,0,0,1-.67.64c1.13-3.72,2.25-7.22,3.37-10.4a5.24,5.24,0,0,0-2.91.54,5.06,5.06,0,0,1,2.46-1.23,4.21,4.21,0,0,1-1.77-1.08,4.08,4.08,0,0,0,2.07.36A9.08,9.08,0,0,0,21,37.91a6.57,6.57,0,0,1,1.88,1.61.41.41,0,0,1,0-.11,25.45,25.45,0,0,1,.42-3.09l0-.1Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-6_1598899230408)"
    },
    d: "M38.16,23c0,.1,0,.25-.1.43s-.07.26-.12.41l-.06.16-.17.46c-.13.32-.3.69-.5,1.1-.05.09-.09.19-.14.28l-.12.19a6.41,6.41,0,0,1-.41.57l-.19.21-.33.32-.23.18a6.14,6.14,0,0,1-1.32.74h.08c.1,0,.21,0,.31-.06a5.26,5.26,0,0,0,1.77-.77,5.74,5.74,0,0,1-3.06,3h0l.26,0,.24-.05a5,5,0,0,0,1.24-.43c-.29.87-.58,1.67-.88,2.41a21.47,21.47,0,0,1-1.11,2.3,12.31,12.31,0,0,1-1.72,2.39,9.44,9.44,0,0,1-5,2.83h.08l-1.32.15h0l0,0c.28-.76.55-1.5.83-2.23a.42.42,0,0,1,0-.1c.27-.73.55-1.44.82-2.13s.6-1.52.9-2.25.62-1.51.92-2.22.64-1.48.95-2.17.49-1.12.74-1.65l.24-.52c.16-.35.32-.68.48-1s.28-.6.43-.9l.14-.29s0,0,0,0L36,23.79h0l.15,0h0A6.1,6.1,0,0,0,38,23.14Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-7_1598899230408)"
    },
    d: "M36.48,15.9c-.37.57-.77,1.21-1.2,1.94a.75.75,0,0,0-.07.12c-.38.63-.78,1.32-1.19,2.07s-.74,1.36-1.13,2.12-.69,1.35-1.05,2.09L36,23.78A4.94,4.94,0,0,0,38.25,22q.21-.3.42-.63a23,23,0,0,0,1.22-2.12,21.69,21.69,0,0,0,.92-2,10.17,10.17,0,0,0,.37-1.1c.07-.29.13-.56.18-.82A45.15,45.15,0,0,1,36.48,15.9Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e"
    },
    d: "M33.8,30.19l-.25,0h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e",
      opacity: 0.3499999940395355,
      isolation: "isolate"
    },
    d: "M33.8,30.19l-.25,0h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-8_1598899230408)"
    },
    d: "M33.8,30.19l-.25,0h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e",
      opacity: 0.3499999940395355,
      isolation: "isolate"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-9_1598899230408)"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be202e",
      opacity: 0.3499999940395355,
      isolation: "isolate"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-10_1598899230408)"
    },
    d: "M34.46,28.08h0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6e71"
    },
    d: "M44.27,14.07l-.32.65-.32-.65h-.16V15h.12v-.73l.32.63H44l.31-.63V15h.13v-.93Zm-1.65,0v.13h.29V15H43v-.8h.29v-.13Z",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApacheLogoIcon);
export default __webpack_public_path__ + "static/media/apache-logo-icon.35a5c968e7b9af7a0b19c927388e2b2e.svg";
export { ForwardRef as ReactComponent };